import { NotableTenant } from '@root/types';
import { useTranslation } from 'react-i18next';
import { Row } from 'antd';
import s from './NotableTenants.module.less';

type Props = {
  notableTenants: NotableTenant[];
};

const NotableTenants = ({ notableTenants = [] }: Props) => {
  const { t } = useTranslation('building');
  return (
    <div className={s.container}>
      <h4 className={s.title}>{t('notableTenants')}</h4>
      <Row>
        {notableTenants.map(notableTenant => (
          <img
            key={notableTenant.companyId}
            className={s.tenantLogo}
            alt={notableTenant.logo.description}
            src={notableTenant.logo.path}
          />
        ))}
      </Row>
    </div>
  );
};

export default NotableTenants;
